<script lang="ts">
  /* eslint-disable svelte/require-each-key */
  import uPlot from "uplot";
  import { stickChartControls } from "../store/app_state";
  import "uplot/dist/uPlot.min.css";
  import { untrack } from "svelte";
  import MyPlot from "./plot_test.svelte";
  import MyBitsPlot from "./plot_status_bits.svelte";
  import DropFile from "../components/request-or-drop-file.svelte";
  import { x53b_740_chart } from "../cardiag/charts/x53b-740.svelte";
  import { raw_chart } from "../cardiag/charts/raw.svelte";
  import type { Icar_chart, Icar_chart_static, ILabel, CarMetrics } from "../cardiag/charts/iface";
  //import { byte_unstuffing } from "../cardiag/byte_unstuffing";
  import { RenixDestuffer } from "../cardiag/renix_destuffer";
  import { EnableGitHubSamples } from "../store/app_state";
  import { getGithubSamples } from "../sample_data/github_samples";
  //import { DiagDataBuffer } from "../store/diag-data";
  import { fetchBinaryData } from "../download";
  import { tooltip } from "../tooltip";

  let { chart_index = 0, chart_index_viewed = 0 } = $props();

  let diag_data = new Uint8Array(0);
  let diag_data_name = $state("");
  let car_charts = [x53b_740_chart, raw_chart];
  let car_chart_class = x53b_740_chart;
  let car_chart: Icar_chart = $state(new car_chart_class());
  let live_simu = $state(false);
  let live = $state(false);

  let yn_arr_version_counter = $state(0);
  let x_arr_version_counter = $state(0);
  const yn_arr_version = $derived({ yn_arr_version_counter }); //  version of y data
  const x_arr_version = $derived({ x_arr_version_counter, len: x_arr_len, x_arr }); //  version of x data

  const n1 = 0;
  const n2 = 200000;
  let x_arr_live = $state(Float64Array.from({ length: n2 - n1 + 1 }, (_, i) => n1 + i));

  const yn_arr = $derived.by(() => {
    //$inspect.trace("input-data");
    //console.log("yn_arr-derived");
    void yn_arr_version_counter;
    if (!car_chart) return [[]];
    return car_chart.get_chart_data();
  });

  //$effect(()=>{yn_arr;});

  const x_arr = $derived.by(() => {
    void x_arr_version_counter;
    return (!live ? car_chart?.get_chart_data()[0].map((_, i) => i) : x_arr_live) ?? [];
  });

  const x_arr_len = $derived(x_arr.length);
  const nmbGraphs = $derived(car_chart.nmbGraphs);

  let error = $state(null);

  const car_metrics = $derived(car_chart?.get_car_metrics());

  let yn_show = $state(
    Array(64)
      .fill()
      .map((e) => true),
  );
  let yn_show_as_bits = $state(
    Array(64)
      .fill()
      .map((e) => false),
  );
  let x_labels: ILabel = $derived({ series_label: "Blk", axis_label: "x" });
  let width = $state(typeof window !== "undefined" ? window.innerWidth - 10 : 1000);
  let height = $state(300);
  let win_innerWidth = $state(typeof window !== "undefined" ? window.innerWidth : 1000);

  const toolTips = $derived.by(() => {
    const res: string[] = [];
    if (!car_metrics) return res;
    for (const cm of car_metrics) {
      const tt = cm2txt(cm);
      res.push(tt);
    }
    //console.log("toolTips", res);
    return res;
  });

  $effect(() => {
    //car_chart.clear_chart_data();
  });

  // svelte-ignore state_referenced_locally
  const syncKey = uPlot.sync("zoom_group" + chart_index);

  function load_data(data: Uint8Array, name = "") {
    live_simulation(false);
    if (isHexContent(data)) {
      diag_data = hexToBinary(data);
    } else {
      diag_data = data;
    }
    diag_data_name = name;
    process_data(diag_data, car_chart, false);
    ++yn_arr_version_counter;
    ++x_arr_version_counter;
  }
  function change_car_chart(car_chart_class: Icar_chart_static) {
    live_simulation(false);
    car_chart = new car_chart_class();
    process_data(diag_data, car_chart, false);
    ++yn_arr_version_counter;
  }

  function live_simulation(simu: boolean) {
    console.log("simu listener", simu);
    if (!simu && live_simu_running) {
      live_simu = false;
      live = false;
      if (live_simu_running) {
        clearTimeout(timeoutId);
        live_simu_running = false;
      }
      car_chart.clear_chart_data();
      process_data(diag_data, car_chart, false);
      ++yn_arr_version_counter;
      ++x_arr_version_counter;
      return;
    }

    if (simu && !live_simu_running) {
      car_chart.clear_chart_data();
      //x_arr_live = generate_live_x_arr(n2);
      live_simu = true;
      live = true;
      live_simu_running = true;
      startTimer(100, 0);
    }
  }

  function generate_live_x_arr(count: number, step: number = 0.015): Float64Array {
    const start = Date.now() / 1000;
    const x = new Float64Array(count);
    for (let i = 0; i < count; i++) {
      x[i] = start + i * step;
    }
    return x;
  }

  let timeoutId = 0;
  let live_simu_running = false;
  function startTimer(chunk_size: number, chunk_nmb: number) {
    timeoutId = setTimeout(() => {
      live_simu_running = true;
      const start = chunk_size * chunk_nmb;
      const end = start + chunk_size;
      if (end >= diag_data.length) return;
      const data = diag_data.subarray(start, end);
      process_data(data, car_chart, true);
      ++yn_arr_version_counter;
      // ++input_data_version; //trigger processing

      //console.log("live simu tick", start, end, data.length);

      // Schedule the next run
      if (live_simu) startTimer(chunk_size, chunk_nmb + 1);
      else {
        live_simu_running = false;
        timeoutId = 0;
      }
    }, 25);
  }

  //startTimer();
  export function hexToBinary(data: Uint8Array): Uint8Array {
    const result = new Uint8Array(data.length);
    let resultIndex = 0;
    let currentByteHex = ""; // Use a small string to collect chars between spaces

    const start = data[0] === 0x9a ? 1 : 0;

    for (let i = start; i < data.length; i++) {
      const char = String.fromCharCode(data[i]);

      // If we hit a space or newline, process what we have and RESET
      if (/\s/.test(char)) {
        if (currentByteHex.length > 0) {
          // Parse whatever we found (handles "A" as 0x0A or "AA" as 0xAA)
          result[resultIndex++] = parseInt(currentByteHex, 16);
          currentByteHex = ""; // <--- This RE-SYNCS the alignment
        }
        continue;
      }

      // Accumulate valid hex chars
      if (/[0-9a-fA-F]/.test(char)) {
        currentByteHex += char;

        // If we have 2 chars, we can optionally auto-commit,
        // but waiting for the space is safer for "dirty" data.
        if (currentByteHex.length === 2) {
          result[resultIndex++] = parseInt(currentByteHex, 16);
          currentByteHex = "";
        }
      }
    }

    return result.slice(0, resultIndex);
  }
  /**
   * Heuristic to detect if a Uint8Array contains Hex text
   * instead of raw binary.
   */
  export function isHexContent(data: Uint8Array): boolean {
    // Check the first 50 bytes (or total length)
    const sampleSize = Math.min(data.length, 50);

    for (let i = 2; i < sampleSize; i++) {
      const byte = data[i];
      // Check if byte is 0-9 (48-57), A-F (65-70), a-f (97-102), or whitespace/colon
      const isHexChar = (byte >= 48 && byte <= 57) || (byte >= 65 && byte <= 70) || (byte >= 97 && byte <= 102) || [10, 13, 32, 58].includes(byte); // \n, \r, space, :

      if (!isHexChar) return false;
    }
    return true;
  }

  /**
   *  @brief generate chart data from binary input
   *  @param data   input raw data u8 array (with hdr and byte stuffing)
   *  @param append  if true, append to the existing chart data instead of replacing it
   *
   */
  function process_data(data: Uint8Array, car_chart: Icar_chart, append: boolean = false) {
    const unstuffing = new RenixDestuffer((arr: Uint8Array, ct: number) => car_chart.process_data_packet(arr, ct));
    if (!append) car_chart.clear_chart_data();
    unstuffing.process_chunk(data);
  }

  const diag_charts = {
    tt: {
      h3:
        "<ul> <lh>Hotkeys:</lh>" + //
        "<li>1,2,3,4,Tab: Change chart page. </li>" +
        "<li>c: make chart controls visible when scrolling</li>" +
        "</ul>",
    },
  };

  let showChartEditor = $state(false);
  let selectOrderIdx = $state(0);
  let selectUnusedMetricsIdx = $state(0);
  function oIdx2cmi(i: number): number {
    const cmi = car_chart.order[i];
    if (cmi >= car_metrics.length) return undefined;
    return cmi;
  }
  function oIdx2cm(i: number): CarMetrics {
    const cmi = car_chart.order[i];
    if (cmi >= car_metrics.length) return undefined;
    return car_metrics[cmi];
  }
  function cm2txt(cm: CarMetrics): string {
    let res = "";
    if (cm?.k) res += `#${cm.k} `;
    res += cm?.name;
    return res;
  }
</script>

{#snippet header()}
  <h3 class="w-screen mx-0 pointer-events-auto" use:tooltip={{ content: diag_charts.tt.h3, allowHTML: true }}>{chart_index + 1} : {diag_data_name}</h3>
{/snippet}

{#snippet bit_chart(idx: number)}
  <MyBitsPlot
    chartData={[x_arr, yn_arr[idx]]}
    chartDataVersions={[x_arr_version, yn_arr_version]}
    labels={[x_labels, car_chart.labels[idx]]}
    packets_per_sec={car_chart.packets_per_sec}
    {syncKey}
    {width}
    {height}
    is_live={live}
    }
  />
{/snippet}

{#snippet val_chart(i: number)}
  <MyPlot
    xData={x_arr}
    xDataVer={x_arr_version}
    yData={yn_arr[i]}
    yDataVer={yn_arr_version}
    y2Data={yn_arr[i + 1]}
    y2DataVer={yn_arr_version}
    labels={[x_labels, car_chart.labels[i], car_chart.labels[i + 1]]}
    packets_per_sec={car_chart.packets_per_sec}
    {syncKey}
    {width}
    {height}
    is_live={live}
    }
  />
{/snippet}

{#snippet enable_chart(i: number)}
  <label use:tooltip={{ content: "y1: " + toolTips[oIdx2cmi(i)] + "<br>y2: " + toolTips[oIdx2cmi(i + 1)], allowHTML: true }}
    ><input type="checkbox" bind:checked={yn_show[i]} />{car_chart.labels[i]?.series_label}, {car_chart.labels[i + 1]?.series_label}</label
  >
  {#if car_chart.labels[i]?.axis_label === "bits" || car_chart.labels[i]?.axis_label === "raw"}
    <label><input type="checkbox" bind:checked={yn_show_as_bits[i]} />bits</label>
  {/if}
{/snippet}

<svelte:window bind:innerWidth={win_innerWidth} onresize={() => (width = window.innerWidth - 10)} />

<!-- begin of experimental -->
<label><input type="checkbox" bind:checked={showChartEditor} />Show Chart Editor</label>
{#if showChartEditor}
  <div class="flex flex-row mx-auto w-fit">
    <div>
      <h5 class="p-0 m-0">Unused Metrics</h5>
      <select size={car_metrics.length} bind:value={selectUnusedMetricsIdx}>
        {#each car_metrics as cm, i}
          {#if !car_chart.order.includes(i)}
            <option value={i}>
              {cm2txt(cm)}
            </option>
          {/if}
        {/each}
      </select>
    </div>
    <div class="flex flex-col mx-auto w-fit">
      <button
        class=""
        onclick={() => {
          if (selectOrderIdx === 0) return;
          [car_chart.order[selectOrderIdx], car_chart.order[selectOrderIdx - 1]] = [car_chart.order[selectOrderIdx - 1], car_chart.order[selectOrderIdx]];
          --selectOrderIdx;
        }}>move up</button
      >
      <button
        class=""
        onclick={() => {
          if (selectOrderIdx + 1 >= car_chart.order.length) return;
          [car_chart.order[selectOrderIdx], car_chart.order[selectOrderIdx + 1]] = [car_chart.order[selectOrderIdx + 1], car_chart.order[selectOrderIdx]];
          ++selectOrderIdx;
        }}>move down</button
      >
      <button
        class=""
        onclick={() => {
          car_chart.order.push(selectUnusedMetricsIdx);
        }}>use this</button
      >
      <button
        class=""
        onclick={() => {
          const remIdx = selectOrderIdx;
          car_chart.order.splice(remIdx, 1);
          if (selectOrderIdx >= car_chart.order.length) selectOrderIdx = car_chart.order.length - 1;
        }}>not use this</button
      >
      <button
        class=""
        onclick={() => {
          car_chart.order.length = 0;
        }}>use none</button
      >
    </div>
    <div>
      <h5 class="p-0 m-0">Used Metrics</h5>
      <select size={car_metrics.length} bind:value={selectOrderIdx}>
        {#each car_chart.order as cmi, i}
          <option value={i}>
            {cm2txt(car_metrics[cmi])}
          </option>
        {/each}
      </select>
    </div>
  </div>
{/if}
<!-- end of experimental -->

<div class="min-w-full text-center">
  <div class="min-w-full mx-auto">
    <!-- 2. The Wide Container (The "Giant Canvas") -->
    <!-- 'w-max' tells it to grow with the charts. 'min-w-full' keeps it at least screen-wide. -->
    <div class="block w-max min-w-full text-left p-4">
      {#if !$stickChartControls}
        <div class="sticky top-0 left-0 z-60 w-screen">
          {@render header()}
        </div>
      {/if}

      <div class="sticky left-0 z-50 w-screen pointer-events-none text-center" class:top-0={$stickChartControls}>
        {#if $stickChartControls}
          {@render header()}
        {/if}
        <div class="mx-auto w-fit pointer-events-auto bg-amber-50 p-2" class:shadow-xl={$stickChartControls}>
          <div class="flex flex-row items-center">
            <div class="flex flex-col">
              <h5 class="m-0 p-0">Data Sources</h5>
              <label><input type="checkbox" bind:checked={$EnableGitHubSamples} />GitHub Data Files</label>
              {#if $EnableGitHubSamples}
                {#await getGithubSamples()}
                  <p>Loading samples URLs...</p>
                {:then list: {url:string, name:string}[]}
                  <select
                    size={6}
                    onchange={(event) => {
                      let url = event.target.value as string;
                      if (url)
                        void fetchBinaryData(url, load_data, (err: string) => {
                          error = err;
                        });
                    }}
                  >
                    {#each list as sample}
                      <option value={sample.url}>{sample.name}</option>
                    {/each}
                  </select>
                {/await}
              {/if}

              {#if import.meta.env.MODE === "mcu"}
                <button
                  onclick={() => {
                    void fetchBinaryData("/f/mnt/sdcard/xr25.bin", load_data, (err: string) => {
                      error = err;
                    });
                  }}>MCU Data Files</button
                >
              {/if}
              {#if chart_index === chart_index_viewed}
                <DropFile onDataLoaded={load_data} mode="button" />
              {/if}

              <label
                ><input
                  type="checkbox"
                  bind:checked={live_simu}
                  onchange={() => {
                    live_simulation(live_simu);
                  }}
                />Live-Simulation</label
              >
            </div>
            <div class="flex flex-col">
              <div>
                <h5 class="m-0 p-0">Parser</h5>
                <select
                  bind:value={car_chart_class}
                  size={3}
                  onchange={() => {
                    change_car_chart(car_chart_class);
                  }}
                >
                  {#each car_charts as cc}
                    <option use:tooltip={{ content: cc.get_info().description }} value={cc}>{cc.get_info().name}</option>
                  {/each}
                </select>
              </div>
              <h5 class="mb-0 p-0">Chart-Size</h5>
              <label>W<input type="number" bind:value={width} min={400} max={5000} step={100} /></label>
              <label>H<input type="number" bind:value={height} min={100} max={1000} step={25} /></label>
            </div>
            <!-- Enable/Disable graphs by checkboxes -->
            <div class="flex flex-col text-left">
              {#each Array.from({ length: Math.floor(nmbGraphs / 2) }, (_, index) => index * 2) as i}
                <div>
                  {@render enable_chart(i)}
                </div>
              {/each}
            </div>
          </div>
          {#if error}
            <p style="color: red;">Error: {error}</p>
          {/if}
        </div>
      </div>
      <!-- Display value-charts with 2 graphs per chart. Bit-Charts have 8 graphs per chart (XXX) -->
      {#if x_arr.length > 0}
        {#each Array.from({ length: Math.floor(nmbGraphs / 2) }, (_, index) => index * 2) as i}
          <div class="text-left">
            <div class="text-center" style="display:{yn_show[i] ? 'block' : 'none'};touch-action: pan-y; width: 100%;">
              {#if yn_show_as_bits[i] && (car_chart.labels[i]?.axis_label === "bits" || car_chart.labels[i]?.axis_label === "raw")}
                {@render bit_chart(i)}
                {@render bit_chart(i + 1)}
              {:else}
                {@render val_chart(i)}
              {/if}
            </div>
          </div>
        {/each}
      {/if}
    </div>
  </div>
</div>
